import React, { useEffect, useState } from "react";
import { Company } from "./Company";
import { User } from "../user/User";
import { Form, Formik } from "formik";
import { CompanyAPI } from "./CompanyAPI";
import { SaveButton } from "../button/Save.Button";
import { EBTextInputV2 } from "../components/common/input/TextLine.input";
import { Label } from "../components/common/Form/elements/FormInputLabel";
import { AttachmentInput } from "../components/common/upload/AttachmentInput";
import { EBTextAreaV2 } from "../components/common/Form/FormElements";
import { message } from "antd";
import { SocialApi } from "../social/Social.api";
import { SocialType } from "../social/Social.model";
import { SocialLinksInput } from "../social/SocialLinks.input";

interface CompanyEditComponentProps {
  company: Company;
  liu: User;
}

export function CompanyEditComponent(props: CompanyEditComponentProps) {
  const [socialTypes, setSocialTypes] = useState<SocialType[]>([]);

  useEffect(() => {
    SocialApi.getAllSocialTypes().then((types) => {
      setSocialTypes(types);
    });
  }, []);

  return (
    <span className="CompanyEditComponent">
      <Formik
        initialValues={{ ...props.company, keywordsStr: props.company.keywords?.join(", ") || "" }}
        onSubmit={(values: any) => {
          const submitValues = { 
            ...values, 
            keywords: values.keywordsStr 
              ? values.keywordsStr.split(",").map((s: string) => s.trim()).filter((s: string) => s.length > 0) 
              : [] 
          };
          return CompanyAPI.updateCompany(props.company.id)
            .executeV2(submitValues)
            .then(() => {
              message.success("Company updated");
            });
        }}
      >
        {(formProps) => (
          <Form>
            <Label label="Short Name:" />
            <EBTextInputV2 name="dl" />

            <Label label="Descriptive Name:" />
            <EBTextInputV2 name="desDl" />

            <Label label="Tagline:" />
            <EBTextInputV2 name="tl" />

            <Label label="Keywords (comma separated):" />
            <EBTextInputV2 name="keywordsStr" />


            <Label label="Industry:" />
            <EBTextInputV2 name="industry" />

            <Label label="Company Size:" />
            <EBTextInputV2 name="companySize" />

            <Label label="Headquarters:" />
            <EBTextInputV2 name="headquarters" />

            <Label label="Specialties (comma separated):" />
            <EBTextInputV2 name="specialties" />

            <Label label="Founded Year:" />
            <EBTextInputV2 name="foundedYear" />

            <Label label="Social Links:" />
            {socialTypes.length > 0 && (
              <SocialLinksInput name="socialLinks" allSocialTypes={socialTypes} />
            )}

            <EBTextAreaV2 name="dd" label={"About"} />

            <Label label="Banner:" />
            <AttachmentInput name="banner" user={props.liu} />

            <Label label="Logo:" required={true} />
            <AttachmentInput name="dp" user={props.liu} required={true} />
            <SaveButton submitting={formProps.isSubmitting} />
          </Form>
        )}
      </Formik>
    </span>
  );
}
